import { JRCAvatar } from '../JRCAvatar/JRCAvatar';
import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { JRCTooltip } from '../JRCTooltip/JRCTooltip';
import { Audience } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import { JRCStyledHref } from '../JRCHref/JRCHref';
import { JRCTypography } from '../JRCTypography/JRCTypography';
import { JRCFlexBox } from '../JRCFlex/JRCFlexBox';
import { JRCModalContent } from '../JRCModal/JRCModalContent';
import { JRCModalLayout } from '../JRCModal/JRCModalLayout';

export type JRCAvatarsProps = {
    audience?: Pick<Audience, '_url' | 'uri' | 'title'>[];
};

const Container = styled.div`
    display: flex;
`;

const Wrapper = styled.button<{ first: boolean }>`
    ${({ first }) => !first && `margin-left: -10px;`}
    z-index: 1;

    & *:hover {
        cursor: pointer;
    }
`;

const Count = styled.div`
    background-color: ${({ theme }) => theme.color.primary};
    height: 24px;
    width: 24px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.color.white};
    z-index: 2;
`;

const AudienceEntry = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
`;

const LIMIT = 5;

export const JRCAvatars = ({ audience }: JRCAvatarsProps) => {
    const theme = useTheme();
    const intl = useIntl();
    const [isModalOpen, setModalOpen] = useState(false);

    return (
        <>
            <Container>
                {audience?.slice(0, LIMIT)?.map((a, index) => (
                    <Wrapper first={index === 0} key={a.uri} onClick={() => (document.location = a._url)}>
                        <JRCTooltip description={a.title}>
                            <JRCAvatar uri={a.uri} cssColor={theme.color.primaryL15} />
                        </JRCTooltip>
                    </Wrapper>
                ))}
                {audience && audience.length > LIMIT && (
                    <Wrapper first={false} onClick={() => setModalOpen(true)}>
                        <Count>{audience.length - LIMIT}</Count>
                    </Wrapper>
                )}
            </Container>
            {audience && audience.length > LIMIT && (
                <JRCModalLayout
                    variant={'fixed-height'}
                    maxHeight={'800px'}
                    open={isModalOpen}
                    closeHandler={() => setModalOpen(false)}>
                    <JRCModalContent
                        overflow={'scroll'}
                        onClickIconClose={() => setModalOpen(false)}
                        title={intl.formatMessage({ id: 'GLOBAL_Audience' })}>
                        <AudienceEntry>
                            {audience.map((a) => (
                                <JRCFlexBox key={a.uri} y={'center'} gap={24}>
                                    <JRCAvatar size={LIMIT} uri={a.uri} />
                                    <JRCStyledHref href={a._url}>
                                        <JRCTypography>{a.title}</JRCTypography>
                                    </JRCStyledHref>
                                </JRCFlexBox>
                            ))}
                        </AudienceEntry>
                    </JRCModalContent>
                </JRCModalLayout>
            )}
        </>
    );
};
